class BaseSlider extends HTMLElement {
  constructor() {
    super();

    this.dataId = null;
    this.slideCount = 0;
  }

  connectedCallback() {
    this.dataId = this.getAttribute('data-id');
    this.slideCount = this.getAttribute('data-slidecount') || 0;
    
    this.initSwiper();
  }

  disconnectedCallback() {
    this.destroySwiper();
  }

  initSwiper() {
    if (this.slideCount === 1) {
      console.info('Swiper not initialized. Only one child element.');
      return null;
    }

    const paginationId = `swiper-pagination-${this.dataId}`;

    const paginationEnabled = {
      pagination: {
        el: `#${paginationId}`,
        type: 'bullets',
        clickable: true,
      },
    };

    this.swiperInstance = new Swiper(this, {
      slidesPerView: 1,
      autoHeight: true,
      preventInteractionOnTransition: true,
      ...paginationEnabled,
    });
  }

  destroySwiper() {
    if (this.swiperInstance) {
      try {
        if (this.swiperInstance.destroyed) {
          console.info('Swiper already destroyed');

          this.swiperInstance = null;

          return null;
        }

        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
      } catch (error) {
        console.error('Error destroying Swiper:', error);

        this.swiperInstance = null; // Fallback
      }
    } else {
      console.log('No Swiper instance to destroy');
    }
  }
}
